import emailjs from '@emailjs/browser';
import React, { useRef, useState } from 'react';
export default function About() {
  const form = useRef();
  const [sending,setSending]= useState(false);
  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true)
    emailjs.sendForm('service_a3s5fjd', 'template_iuzmzv3', form.current, '2iTxB88mm3o47Nyqq')
      .then((result) => {
          console.log(result.text);
          form.current.reset()
          setSending(false)
      }, (error) => {
          console.log(error.text);
          setSending(false)
      });
  };
  return (
    <div className="about container" dir="rtl">
      <h2>عنا </h2>
      <p>
      يقدم <span className='text-primary-color'> 1sTest </span> دروس نظرية عالية الجودة في القيادة والتي ستساعدك على إتقان مادة الاختبار النظري واجتيازها بثقة. صُممت دروسنا لتكون جذابة وتفاعلية وسهلة المتابعة ومناسبة لاحتياجات التعلم الفردية الخاصة بك.

      </p>
      <p>
      نحن نغطي جميع الموضوعات المهمة التي ستواجهها في الاختبار النظري ، بما في ذلك إشارات الطرق والقواعد واللوائح وإدراك المخاطر وغير ذلك الكثير. <span className='text-primary-color'> 1sTest </span> لمساعدتك على تعلم المعلومات والاحتفاظ بها بشكل فعال.

      </p>
      <b> تم تصميم الموقع على يد طلاب Math Academy و خبراء MassDev  </b>
        {/* CONTACT_US */}
        <div className="contact">
          <br></br>
      <h3 className="text-primary-color">تواصل معنا </h3>
      <form  ref={form} onSubmit={sendEmail}  className="contact-form">
        <label>
          <span>بريدك الالكتروني </span>
          <input type="email" name="email" required />
        </label>
        <label>
          <span>رسالتك </span>
          <textarea name="message" required></textarea>
        </label>
        <button>{sending?" جاري الارسال ...": " ارسال "  }</button>
      </form>
    </div>
    </div>
  )
}
